import * as React from "react";
const SvgQobra = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80",
  ...props
}, /*#__PURE__*/React.createElement("rect", {
  width: "80",
  height: "80",
  rx: "16",
  fill: "#00161F"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.8351 4.3026) scale(2.62035)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.9815 4.8457C8.53264 4.8457 9.83757 5.48585 10.4777 6.4707L10.6501 5.14116H15.3281L12.9152 22.4006H8.23718L9.00044 16.9101C8.28643 17.7964 7.12922 18.412 5.6027 18.412C2.62353 18.412 0.826172 16.0483 0.826172 12.626C0.826172 8.41577 3.2883 4.8457 6.9815 4.8457ZM9.68984 12.0105L9.78833 11.3949C9.9853 9.8438 9.22204 8.78509 7.99097 8.78509C6.51369 8.78509 5.55346 10.287 5.55346 12.1828C5.55346 13.6108 6.16899 14.4726 7.37544 14.4726C8.63112 14.4726 9.49287 13.5862 9.68984 12.0105Z",
  fill: "#fff"
})));
export default SvgQobra;
//# sourceMappingURL=Qobra.js.map